import { Chapter } from '../entities/chapter.entity';
import { Course } from '../entities/course.entity';
import { NotionRank } from '../enums/notion.enums';
import { FiltersFormValue, QueryData } from './query-data.payload';

export interface NotionFormValue {
  chapter: Chapter;
  name: string;
  rank: NotionRank;
}

export class UpdateNotionPayload {
  name: string;
  rank: NotionRank;

  constructor(formValue: Partial<NotionFormValue>) {
    this.name = formValue.name;
    this.rank = formValue.rank;
  }
}

export class AddNotionPayload extends UpdateNotionPayload {
  chapterId: string;
  courseId: string;

  constructor(formValue: Partial<NotionFormValue>, courseId: string) {
    super(formValue);
    this.chapterId = formValue.chapter.id;
    this.courseId = courseId;
  }
}

export interface WNotionFiltersFormValue extends FiltersFormValue {
  name?: string;
}

export class WNotionQueryData extends QueryData {
  name?: string;

  constructor(filtersFormValue: WNotionFiltersFormValue) {
    super(filtersFormValue);
    this.name = filtersFormValue.name;
  }
}

export interface CourseNotionsFiltersFormValue extends FiltersFormValue {
  courseId?: string;
}
